import { useState } from "react";
import type { RegenerateTranscriptionRequestBody } from "@/common/types/regenerateTranscription";
import { regenerateTranscription } from "@/services/regenerateTranscription";

export const useRegenerateTranscription = (): {
  regenerate: (body: RegenerateTranscriptionRequestBody) => Promise<void>;
  result: boolean | null;
  loading: boolean;
  error: boolean;
} => {
  const [result, setResult] = useState<boolean | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  const regenerate = async (
    body: RegenerateTranscriptionRequestBody
  ): Promise<void> => {
    setLoading(true);
    setError(false);
    try {
      await regenerateTranscription(
        body.fileId,
        body.audioTranscriptionProviderId
      );
      setResult(true);
    } catch {
      setResult(false);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return { regenerate, result, loading, error };
};
